import { useQuery } from '@tanstack/react-query'
import { ProfileSelector as PageProfileSelector } from '@web/components/page-components/DonationForm'
import { PageProfileSelectorProps } from '@web/components/page-components/DonationForm/components/molecules/ProfileSelector'
import { ProfileQueryOrderType } from '@web/graphql-queries/graphql'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { toSearchParams } from 'apps/fe-donation/utils'

const ProfileSelector = (props: PageProfileSelectorProps) => {
  const charityId = usePageStore((state) => state.charityId)
  const campaignId = usePageStore((state) => state.campaignId)
  const isLiveMode = usePageStore((state) => state.isLiveMode)
  const selectedProfileId = usePageStore((state) => state.profileId)

  const { data, isPending } = useQuery({
    queryKey: ['profiles', campaignId],
    queryFn: () =>
      fetch(
        '/api/profiles?' +
          toSearchParams({
            charityId,
            campaignId,
            isLiveMode,
            isApprovedOnly: false,
            orderBy: ProfileQueryOrderType.DateAscending,
          }),
      )
        .then((res) => res.json())
        .catch(() => []),
    enabled: !!charityId && !!campaignId,
  })

  if (isPending || !data?.length) {
    return null
  }

  return (
    <PageProfileSelector
      {...props}
      teams={data}
      selectedProfileId={selectedProfileId ?? ''}
      onChange={(profileId) => {
        usePageStore.setState({
          profileId,
          profileData: profileId ? data.find((x) => x.id === profileId) : undefined,
        })
      }}
    />
  )
}

export default ProfileSelector
